<template>
  <div id="app">
    <div class="un_index">
      <div class="index_one">
        <div class="index_one_title">
          <i class="el-icon-s-data"></i>&nbsp;统计分析
        </div>
        <div class="index_one_form">
          <el-form :inline="true" :model="declareForm" class="demo-form-inline">
            <el-form-item label="时间:">
              <span
                :class="{ time_listC: timeActive == item.id }"
                class="time_list"
                @click="timeClick(item.id)"
                v-for="item in timeList"
                :key="item.id"
                >{{ item.name }}</span
              >
            </el-form-item>
            <el-form-item>
              <el-date-picker
                size="small"
                v-model="declareForm.time"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="pickerChange"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button size="small" @click="watchStatisticss" type="primary"
                >查询</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="dexportTeachers"
                >导出数据统计&nbsp;<i class="el-icon-download"></i
              ></el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="index_one_sum">
          <div class="index_one_title">观看统计汇总</div>
          <div class="one_centent">
            <div class="sum_list">
              <div class="index_one_title sum_list_wenz">
                用户观看人次（PV）
              </div>
              <div class="index_one_title sum_list_wenz">
                <span class="sum_list_sum">{{ summaryData.userViewPV }}</span>
              </div>
            </div>
            <div class="sum_list">
              <div class="index_one_title sum_list_wenz">
                独立访问人数（UV）
              </div>
              <div class="index_one_title sum_list_wenz">
                <span class="sum_list_sum">{{ summaryData.userAccessUV }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="index_two">
        <div class="index_one_title index_title">集团校所在地区访问统计</div>
        <el-table
          :header-cell-style="{ background: '#DFE7FC', height: '48px' }"
          :row-style="{ height: '48px' }"
          :data="areaList"
          border
          style="width: 100%"
        >
          <el-table-column align="center" type="index" width="50" label="序号">
          </el-table-column>
          <el-table-column align="center" prop="provinceName" label="地域">
          </el-table-column>
          <el-table-column
            align="center"
            prop="userViewPV"
            label="用户观看人次"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="userAccessUV"
            label="独立访问人数"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="index_there">
        <div class="index_one_title index_title course_title">
          课程观看情况统计
          <el-button
            @click="exportStatis"
            style="float: right"
            size="small"
            type="primary"
            >课程观看统计导出&nbsp;<i class="el-icon-download"></i
              ></el-button
          >
        </div>
        <el-table
          :header-cell-style="{ background: '#DFE7FC', height: '48px' }"
          :row-style="{ height: '48px' }"
          :data="courseList"
          border
          style="width: 100%"
        >
          <el-table-column align="center" prop="courseName" label="课程">
          </el-table-column>
          <el-table-column align="center" prop="dateTime" label="时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="userViewPV"
            label="用户观看人次"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="userAccessUV"
            label="独立访问人数"
          >
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button @click="liveStat(scope.row)" type="text"
                >查看详细统计</el-button
              >
              <el-button @click="bigData(scope.row)" type="text"
                >数据大屏</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center">
          <el-button
            v-if="areaListNum * 10 <= areaLists.length"
            @click="loadingSum"
            type="text"
            >加载更多</el-button
          >
          <el-button v-else type="text">没有更多了~</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { dexportTeacher, watchStatistics,exportStatis } from "@/api/home";
export default {
  data() {
    return {
      timeList: [
        { id: 1, name: "今天" },
        { id: 3, name: "近7天" },
        { id: 4, name: "近14天" },
        { id: 5, name: "近30天" },
      ],
      timeActive: 1,
      declareForm: {
        time: [],
      },
      summaryData: {},
      courseList: [],
      areaList: [],
      areaLists: [],
      areaListNum: 1,
    };
  },
  created() {
    this.watchStatisticss();
  },
  methods: {
    // 时间点击事件
    timeClick(id) {
      this.timeActive = id;
      this.watchStatisticss();
    },
    // 数据导出
    dexportTeachers() {
      let beginTime = null;
      let endTime = null;
      if (this.declareForm.time.length !== 0) {
        beginTime = this.declareForm.time[0];
        endTime = this.declareForm.time[1];
      }
      let time = "";
      if (this.declareForm.time.length !== 0) {
        time =
          this.formaTime(this.declareForm.time[0]) +
          "-" +
          this.formaTime(this.declareForm.time[1]);
      } else {
        let idx = this.timeList.findIndex((item) => item.id == this.timeActive);
        time = this.timeList[idx].name;
      }
      let name = "爱慧直播" + time + "观看统计";
      let params = {
        timeRange: this.timeActive,
      };
      if (beginTime) {
        params.beginTime = beginTime;
        params.endTime = endTime;
      }
      dexportTeacher(params, name);
    },
    // 查询数据统计
    watchStatisticss() {
      let beginTime = null;
      let endTime = null;
      let timeRange = null;
      if (this.timeActive) {
        timeRange = this.timeActive;
      }
      if (this.declareForm.time.length !== 0) {
        beginTime = this.declareForm.time[0];
        endTime = this.declareForm.time[1];
      }
      let params = {
        timeRange: timeRange,
        beginTime: beginTime,
        endTime: endTime,
      };
      watchStatistics(params).then((res) => {
        this.summaryData = res.data.data.summary;
        // this.courseList = res.data.data.courseList;
        this.areaList = res.data.data.areaList;
        this.areaLists = res.data.data.courseList;
        this.courseList = this.areaLists.slice(0, 10);
      });
    },
    // 加载更多
    loadingSum() {
      if (this.areaListNum * 10 >= this.areaLists.length) {
        this.$message.error("没有更多啦");
        return false;
      }
      let num = this.areaListNum + 1;
      this.areaListNum = num;
      this.courseList = this.areaLists.slice(0, num * 10);
    },
    // 时间格式化
    formaTime(time) {
      let Month = new Date(time.toString()).getMonth() + 1;
      let Day = new Date(time.toString()).getDate();
      return Month + "月" + Day + "日";
    },
    // 日期变化
    pickerChange(e) {
      if (e != null) {
        this.timeActive = "";
      } else {
        this.timeActive = 1;
      }
    },
    // 查看统计详情
    liveStat(row) {
      this.$router.push({
        path: "/liveStat",
        query: {
          lessonId: row.lessonId,
          courseName: row.courseName,
        },
      });
    },
    // 数据大屏
    bigData(row){
      let url = 'http://bigdata.welaiedu.cn/?lessonId=' + row.lessonId
      window.open(url,'_blank')
    },
    // 整学期按照课程维度统计导出
    exportStatis(){
      let params = {
        timeRange:this.timeActive,
        beginTime:this.declareForm.time[0] || '',
        endTime:this.declareForm.time[1] || ''
      }
      let name = '课程维度统计'
      exportStatis(params,name)
    }
  },
};
</script>
<style scoped>
.un_index {
  max-width: 1600px;
  margin: 0 auto;
}
.index_one_title {
  color: #284391;
}
.course_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.time_list {
  display: inline-block;
  padding: 0px 20px;
  border: 1px solid #517dff;
  cursor: pointer;
  line-height: 30px;
  margin-right: 10px;
  border-radius: 5px;
}
.time_listC {
  color: #fff;
  background-color: #517dff;
}
.index_one_form {
  margin-top: 15px;
}
.sum_list {
  display: inline-block;
  width: 180px;
  height: 80px;
  margin-right: 20px;
  border: 1px solid #909fc8;
  border-radius: 4px;
  padding: 15px 30px;
  box-sizing: border-box;
}
.sum_list_wenz {
  font-size: 12px;
}
.sum_list_sum {
  font-size: 30px;
  font-weight: 700;
}
.one_centent {
  margin-top: 20px;
}

.index_two {
  margin-top: 20px;
}
.index_there {
  margin-top: 20px;
}
.index_title {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/unIndex.vue